import { buttonVariants } from '@/components/ui/button';
import { cn } from '@/utils';
import { SOCIAL_LINKS } from '@/constants/social-links';

interface SocialMenuProps {
	className?: string;
	size?: 'sm' | 'md' | 'lg';
	collapsed?: boolean;
	direction?: 'row' | 'col';
}

export function SocialMenu({ className, size = 'md', collapsed = false, direction }: SocialMenuProps) {
	const sizeMap = {
		sm: 'h-8 w-8',
		md: 'h-10 w-10',
		lg: 'h-12 w-12',
	} as const;

	const iconSizeMap = {
		sm: 'h-4 w-4',
		md: 'h-5 w-5',
		lg: 'h-6 w-6',
	} as const;

	const resolvedSize = collapsed ? 'sm' : size;
	const resolvedDirection = direction ?? (collapsed ? 'col' : 'row');
	const containerClasses = cn('flex gap-2', resolvedDirection === 'col' ? 'flex-col items-center' : 'items-center', className);

	return (
		<div className={containerClasses}>
			{SOCIAL_LINKS.map(({ label, href, Icon }) => (
				<a
					key={label}
					href={href}
					target="_blank"
					rel="noreferrer"
					aria-label={label}
					className={cn(
						buttonVariants({ variant: 'default', size: 'icon' }),
						'inline-flex items-center justify-center rounded-full border-2 border-border bg-popover/40 text-popover-foreground hover:bg-popover/90',
						sizeMap[resolvedSize],
					)}
				>
					<Icon className={iconSizeMap[resolvedSize]} />
				</a>
			))}
		</div>
	);
}
